import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
import { Tooltip } from 'antd';
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
//     createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import DeleteIcon from "@mui/icons-material/Delete";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
// import Tooltip from "@mui/material/Tooltip";
import success from "../../assets/img/success.png";
import BackButton from "../../components/BackButton/BackButton";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getLanguageListAdmin } from "../../redux/actions/adminGetLanguageListAction";
import { AdmingetLanguageMappingLists } from "../../redux/actions/adminGetLanguageMappingListAction";
import { getAdminmappingLanguage } from "../../redux/actions/adminMappingLanguageAction";
import { deleteLanguageMappingAdmin } from '../../redux/actions/adminDeleteLanguageMappingAction';
import val from '../../getThemeDetails';
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});
const AdminMappingLanguage = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);
    const [GetwalletOwnerIdResponse, setGetwalletOwnerIdResponse] = useState([]);
    const [getLanguageName, setGetLanguageName] = useState([])
    const [getLanguageNameListStatus, setGetLanguageNameListStatus] = useState(false);
    const [getLanguageNameListArray, setGetLanguageNameListArray] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState([]);
    const [languageList, setLanguageList] = useState([])
    const [walletOwnerID, setwalletOwnerID] = useState('');
    const [GetWalletOwnerID, setGetWalletOwnerID] = useState('');
    const [getMappingLanguageListStatus, setGetMappingLanguageListStatus] = useState(false);
    const [getMappingLanguageListArray, setGetMappingLanguageListArray] = useState("");
    const [mapLanguageStatus, setMapLanguageStatus] =
        useState(false);
    const [mapLanguageStatusResArray, setMapLanguageStatusResArray] =
        useState("");
    const [deleteLanguageStatus, setDeleteLanguageStatus] = useState(false)
    const [deleteLanguageArray, setDeleteLanguageArray] = useState("")
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [code, setCode] = useState("");
    const [deleteNotification, setDeleteNotification] = useState(false)
    const [checkListNotification, setCheckListNotification] = useState(false)

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const getWalletOwnerIdRes = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const GetWalletOwnerIdResPonse = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const getLanguageListRes = useSelector(({ adminGetLanguagesLists }) => adminGetLanguagesLists);
    const getLanguageMappingListRes = useSelector(({ adminGetLanguagesMappingsLists }) => adminGetLanguagesMappingsLists);
    const MappingLanguagesRes = useSelector(({ adminMappingLanguagesLists }) => adminMappingLanguagesLists)
    const deleteLanguageMappingRes = useSelector(({ adminDeleteLanguagesLists }) => adminDeleteLanguagesLists)
    var authToken = regenerateTokenRes.data.AuthToken;

    const dispatch = useDispatch();
    const classes = useStyles();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleNoticationClose = () => {

        setCheckListNotification(false);
        setDeleteNotification(false);
    };
    const handleClose = () => {

        setDeleteOpen(false)


    }

    const handleChange = ({ target: { name, value } }) => {

        if (name === 'walletOwnerID') {
            setwalletOwnerID(value)
            console.log("vvvaaall", value)
            disabledBankTypes(value, getMappingLanguageListArray, languageList);

        }
        // if (name === "getLanguageName") {
        //     // setBankName(value)
        //     setGetLanguageName(value == "Select Language" ? "" : value);

        // }

        // if (name === "languageList") {
        //     setSelectedLanguage(value === "Select Language" ? "" : value);
        //     // console.log('Selected Country: ', value);
        // }

        if (name === 'languageList') {
            if (value.includes('all')) {
                setSelectedLanguage(
                    selectedLanguage.length === languageList.filter((ch) => !ch.disabled).length
                        ? []
                        : languageList.filter((ch) => !ch.disabled).map((x) => x.languageName)
                )
            } else {
                setSelectedLanguage(value);
            }
        }

        if (name === 'GetWalletOwnerID') {
            setGetWalletOwnerID(value)
        }


    };

    const getLanguageResp = () => {
        if (getLanguageListRes.data.status === 'success') {
            setIsLoading(false);
            setLanguageList(getLanguageListRes.data.customerMasterDetailsRequestVOList);

            // testLangList()
        }
        if (getLanguageListRes.data.status === 'failed') {
            if (
                getLanguageListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getLanguageListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        getLanguageResp();
    }, [getLanguageListRes.data.status]);

    useEffect(() => {
        getLanguageListListReq()
    }, []);

    const getLanguageListListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,

            }
        }
        dispatch(getLanguageListAdmin(req, authToken));
    };
    useEffect(() => {
        setSelectedLanguage('')
    }, [walletOwnerID])

    const getWalletOwnerIdReq = () => {
        const req = {

            loginDetails: {
                // adminId: regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId")
                adminId: val.adminIDS

            }
        }
        dispatch(getWalletOwnerIdAndNameList(req, authToken));
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdReq();
        }
    }, [regenerateTokenRes.data.status]);



    useEffect(() => {
        if (getWalletOwnerIdRes.data.status === 'success') {
            setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
        }
        if (getWalletOwnerIdRes.data.status === 'failed') {
            if (
                getWalletOwnerIdRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWalletOwnerIdRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getWalletOwnerIdRes.data.status])

    // ------Search
    const getWalletOwnerIdRequest = () => {
        const req = {

            loginDetails: {
                // adminId: regenerateTokenRes.data.partnerId
                adminId: val.adminIDS

            }
        }
        dispatch(getWalletOwnerIdAndNameList(req, authToken));
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdRequest();
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (GetWalletOwnerIdResPonse.data.status === 'success') {
            setGetwalletOwnerIdResponse(GetWalletOwnerIdResPonse.data.ownerList);
        }
        if (GetWalletOwnerIdResPonse.data.status === 'failed') {
            if (
                GetWalletOwnerIdResPonse.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                GetWalletOwnerIdResPonse.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [GetWalletOwnerIdResPonse.data.status])


    const adminGetLanguageMappingListReq = () => {
        setIsLoading(true);
        setGetMappingLanguageListStatus(true);

        const searchreq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: ""
                // walletOwnerId: regenerateTokenRes.data.partnerId,

            }
        }
        dispatch(AdmingetLanguageMappingLists(searchreq, authToken));

    }
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            adminGetLanguageMappingListReq();
        }
        // },[]);
    }, [regenerateTokenRes.data.status]);

    const adminGetLanguageMappingFunc = () => {
        if (getMappingLanguageListStatus) {
            if (getLanguageMappingListRes.data.status == "success") {
                setGetMappingLanguageListArray([].concat(getLanguageMappingListRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);

            }
            if (getLanguageMappingListRes.data.status == "failed") {
                setGetMappingLanguageListArray(getLanguageMappingListRes.data);
                setIsLoading(false);
                if (
                    getLanguageMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getLanguageMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            // if (getLanguageMappingListRes.data.status == "NOT FOUND") {
            //     setGetMappingLanguageListArray(getLanguageMappingListRes.data)
            //     setIsLoading(false)
            // }
        }
    }

    useEffect(() => {
        adminGetLanguageMappingFunc();
    }, [getLanguageMappingListRes.data.status]);

    //languageName
    //languageList
    // languageName

    const disabledBankTypes = (wid, marr, cclist) => {
        console.log("ccccclllllist", cclist);
        console.log("mmmaaarrrrr", marr);

        let mapped = [].concat(marr).filter(ch => ch.walletOwnerId === wid).map(x => x.languageName);
        console.log("maappppppeddd", mapped)
        for (let i = 0; i < cclist.length; i++) {
            cclist[i].disabled = false;

            for (let j = 0; j < mapped.length; j++) {
                if (cclist[i].languageName == mapped[j]) {
                    cclist[i].disabled = true;
                    break;
                }
            }
        }

        setLanguageList(cclist);
    }

    const getMappingLanguageReq = () => {
        const getIda = (ma, ar) => {
            let fa = [];
            const bn = ma.map(x => x.languageName);
            for (let i = 0; i < ar.length; i++) {
                fa.push(ma[bn.indexOf(ar[i])].id)
            }
            return fa
        }

        setMapLanguageStatus(true)
        let reqMap = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: walletOwnerID || localStorage.getItem("walletOwnerId"),
                mappingIdList: getIda(languageList, selectedLanguage).length == 0 ? '' : getIda(languageList, selectedLanguage)
            }
        }
        dispatch(getAdminmappingLanguage(reqMap, authToken || sessionStorage.getItem("authToken")));

    }


    // function testLangList(langNameList) {
    //     console.log("laangnammmm", langNameList)
    //     console.log("gggeeetttlangnameeee", getMappingLanguageListArray)
    //     const updatedLangNameList = [].concat(langNameList).map(langItem => {

    //         if ([].concat(getMappingLanguageListArray).length > 0) {
    //             const index = [].concat(getMappingLanguageListArray).findIndex(x => x.id === langItem.id);

    //             if (index > -1)
    //                 return { ...langItem, ...{ disabled: true } }
    //             return { ...langItem, ...{ disabled: false } }
    //         }



    //     })
    //     console.log("getMappingLanguageListArray//////", getMappingLanguageListArray)
    //     // console.log("bbbbankLissssttt", getBankNameListArray)
    //     setLanguageList(updatedLangNameList)
    //     console.log("update", updatedLangNameList)

    //     return updatedLangNameList;


    // }

    const checkLanguageNameFunc = () => {
        if (mapLanguageStatus) {
            if (MappingLanguagesRes.data.status == "success") {
                setMapLanguageStatusResArray(MappingLanguagesRes.data)
                setCheckListNotification(true)
                adminGetLanguageMappingListReq()
                setwalletOwnerID('')


            }
            if (MappingLanguagesRes.data.status == "failed") {
                setMapLanguageStatusResArray(MappingLanguagesRes.data)
                setCheckListNotification(true)
                if (
                    MappingLanguagesRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    MappingLanguagesRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        checkLanguageNameFunc()
    }, [MappingLanguagesRes.data.status])


    const adminGetMappingLangListRequest = () => {
        setIsLoading(true);
        setGetMappingLanguageListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: GetWalletOwnerID
            }
        }
        dispatch(AdmingetLanguageMappingLists(searchReq, authToken || sessionStorage.getItem("authToken")));

    }

    const getMappingLangListAdminFunc = () => {
        if (getMappingLanguageListStatus) {
            if (getLanguageMappingListRes.data.status == "success") {
                setGetMappingLanguageListArray([].concat(getLanguageMappingListRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);


            }
            if (getLanguageMappingListRes.data.status == "failed") {
                setGetMappingLanguageListArray(getLanguageMappingListRes.data);
                setIsLoading(false);
                if (
                    getLanguageMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getLanguageMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getLanguageMappingListRes.data.status == "NOT FOUND") {
                setGetMappingLanguageListArray(getLanguageMappingListRes.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        getMappingLangListAdminFunc();
    }, [getLanguageMappingListRes.data.status]);

    useEffect(() => {
        if (getLanguageMappingListRes.data.status == "success") {
            setPage(0);
        }
        if (getLanguageMappingListRes.data.status === 'failed') {
            if (
                getLanguageMappingListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getLanguageMappingListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getLanguageMappingListRes.data.status]);

    const deleteUserFunc = (code) => {

        setCode(code)
        setDeleteOpen(true);
    };
    const deleteLanguageMappingReq = () => {
        setDeleteLanguageStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: regenerateTokenRes.data.partnerId,
                mappingId: code
            }
        }
        dispatch(deleteLanguageMappingAdmin(req, authToken));
        setDeleteOpen(false)
    }
    const deleteLanguageMappingFunc = () => {
        if (deleteLanguageStatus) {
            if (deleteLanguageMappingRes.data.status == "success") {
                setDeleteLanguageArray(deleteLanguageMappingRes.data)
                setDeleteNotification(true)
                adminGetMappingLangListRequest()

            }
            if (deleteLanguageMappingRes.data.status == "failed") {
                setDeleteLanguageArray(deleteLanguageMappingRes.data)
                setDeleteNotification(true);
                if (
                    deleteLanguageMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    deleteLanguageMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        deleteLanguageMappingFunc()
    }, [deleteLanguageMappingRes.data.status])

    // function testLanguageList(langMapping, LangNameList) {
    //     const updatedLanguageNameList = [].concat(LangNameList).map(languageItem => {
    //         const index = getMappingLanguageListArray.findIndex(langMappingItem => langMappingItem.id === LangNameList.id);

    //         if (index > -1)
    //             return { ...languageItem, ...{ disabled: true } }
    //         return { ...languageItem, ...{ disabled: false } }
    //     })
    //     languageList(updatedLanguageNameList)
    //     console.log("update language", updatedLanguageNameList)

    //     return updatedLanguageNameList;


    // }


    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <DialogTitle>Create Mapping Language</DialogTitle>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                variant='standard'
                                fullWidth={true}
                                name="walletOwnerID"
                                value={walletOwnerID || "Select Owner Id"}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>



                        <Grid item xs={12} sm={12} md={4} lg={4}>

                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}>
                                <InputLabel id='multipleCountrySelect'>Select Language Name</InputLabel>
                                <Select
                                    labelId='multipleCountrySelect'
                                    multiple
                                    fullWidth={true}
                                    value={selectedLanguage || []}
                                    input={<Input />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={handleChange}
                                    name='languageList'
                                >
                                    {/* <MenuItem>
                                        <Checkbox
                                            color='primary'
                                            checked={selectedLanguage.length === languageList.length}
                                            indeterminate={
                                                selectedLanguage.length > 0 && selectedLanguage.length < languageList.length
                                            }
                                            onChange={handleSelectAll}
                                        />
                                        <ListItemText primary="Select All" />

                                    </MenuItem> */}

                                    {/* <MenuItem key='all' value='all'>
                                        <Checkbox color='primary' checked={selectedLanguage.length === languageList.length} />
                                        <ListItemText primary='Select All' />
                                    </MenuItem> */}
                                    <MenuItem key='all' value='all'>
                                        <Checkbox color='primary' checked={selectedLanguage.length === languageList.filter((ch) => !ch.disabled).length} />
                                        <ListItemText primary='Select All' />
                                    </MenuItem>
                                    {
                                        languageList && [].concat(languageList).map((x, index) => {
                                            return (

                                                // <MenuItem key={index} value={`${x.languageName}`}>
                                                //     <Checkbox color='primary' checked={selectedLanguage.indexOf(`${x.languageName}`) > -1} />
                                                //     <ListItemText primary={x.languageName} />
                                                // </MenuItem>
                                                // <MenuItem key={index} value={`${x.languageName}`}>
                                                //     <Checkbox
                                                //         color='primary'
                                                //         checked={selectedLanguage.indexOf(`${x.languageName}`) > -1}
                                                //         onChange={(event) => handleBankCheckboxChange(event, x.languageName)}
                                                //     />
                                                //     <ListItemText primary={x.languageName} />
                                                // </MenuItem>

                                                <MenuItem key={index} value={`${x.languageName}`} disabled={x.disabled}>
                                                    <Checkbox color='primary' checked={selectedLanguage.indexOf(`${x.languageName}`) > -1} />
                                                    <ListItemText primary={x.languageName} />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={getMappingLanguageReq}
                            >
                                Create

                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                <Card>
                    <DialogTitle>Search</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                variant='standard'
                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                name="GetWalletOwnerID"
                                value={GetWalletOwnerID || "Select Owner Id"}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {GetwalletOwnerIdResponse &&
                                    [].concat(GetwalletOwnerIdResponse).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={adminGetMappingLangListRequest}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getMappingLanguageListArray.length == undefined ||
                    !getMappingLanguageListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >

                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Wallet Owner Name{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Language Code
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Language Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>





                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getMappingLanguageListArray &&
                                                []
                                                    .concat(getMappingLanguageListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.walletOwnerName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.languageCode}
                                                            </TableCell>
                                                            <TableCell align="center">{row.languageName}</TableCell>
                                                            <TableCell align="center">
                                                                <Tooltip title="Delete">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px",
                                                                            // margin: "0 8px"

                                                                        }}
                                                                        onClick={() =>
                                                                            deleteUserFunc(row.id)
                                                                        }
                                                                    >
                                                                        {
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getMappingLanguageListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>
            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                padding: "8px"
                            }}
                            // variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                width: "60px"
                            }}
                            onClick={deleteLanguageMappingReq}

                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {MappingLanguagesRes.data.status == "success" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"

                            // className="text-center lightThemeBackground"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapLanguageStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {MappingLanguagesRes.data.status == "failed" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"

                            // className="text-center lightThemeBackground"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapLanguageStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {deleteLanguageMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"

                            // className="text-center lightThemeBackground"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteLanguageArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {deleteLanguageMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"

                            // className="text-center lightThemeBackground"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteLanguageArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminMappingLanguage